import { useState } from 'react';
import Card from 'components/atoms/Card';
import Typography from 'components/atoms/Typography';
import BackButton from 'components/molecules/BackButton';
import KitPreviewCard from 'pages/_AdminAuthoringPages/_components/KitPreviewCard';
import Button from 'components/atoms/Button';
import KitForm from 'pages/_AdminAuthoringPages/_components/KitForm';
import { SubmitHandler } from 'react-hook-form';
import InAppRoutes, { pushProgressive } from 'utils/router';
import { useThunkDispatch } from 'utils/reduxHook';
import { toast } from 'react-toastify';
import { createKit } from 'actions/requests';
import KitTemplatesList from 'pages/_AdminAuthoringPages/_components/KitTemplatesList';
import { Kits, Templates, KitResource, PlaybookResource } from 'utils/gloo-types';
import PlaybookResourcesList from 'pages/_AdminAuthoringPages/PlaybookResourcesList';
import { omit } from 'lodash';

function AdminKitCreate() {
  const [preview, setPreview] = useState<Partial<Kits>>({
    metadata: {},
  });
  const [selectedTemplates, setSelectedTemplates] = useState<Templates[]>();
  const [selectedKitResources, _] = useState<KitResource[]>([]);
  const [selectedResources, setSelectedResources] = useState<PlaybookResource[]>([]);
  const dispatch = useThunkDispatch();

  const handleSubmit: SubmitHandler<Partial<Kits>> = async (kitFormData) => {
    const selectedTemplateIds = selectedTemplates.map((template) => template.id);

    const newKitData = {
      ...omit(kitFormData, ['featuredPriority', 'archivedAt']),
      title: kitFormData.title || undefined,
      subtitle: kitFormData.subtitle || undefined,
      shortDescription: kitFormData.shortDescription || undefined,
      longDescription: kitFormData.longDescription || undefined,
      instructions: kitFormData.instructions || undefined,
      metadata: {
        ...kitFormData.metadata,
        author: kitFormData.metadata.author || undefined,
      },
      templateIds: selectedTemplateIds,
      resources: selectedResources,
      kitResources: selectedKitResources,
    };

    const newKit = await dispatch(createKit(newKitData));
    if (!newKit.error) {
      pushProgressive(InAppRoutes.AdminAuthoringHome);
      toast.success('Kit Created');
    }
  };

  return (
    <article className="container-1">
      <Card className="flex items-center justify-between p-4 m-2">
        <BackButton
          route={InAppRoutes.AdminAuthoringHome}
          text="Cancel"
          type="tertiary"
          size="small"
          dataDurableId="adminKitCreateBackButton"
        />
        <Typography className="text-thryveGreenDark flex-grow" variant="h1">
          Create Kit
        </Typography>
        <Button
          icon="save"
          iconPosition="left"
          buttonType="submit"
          dataDurableId="adminKitCreateSaveButton"
          form="kitCreateForm"
          type="primary"
          text="SAVE"
        />
      </Card>
      <section className="grid grid-cols-4 grid-rows-6">
        <Card className="p-4 m-2 col-span-3 row-span-6">
          <KitForm formId="kitCreateForm" handleOnChange={setPreview} handleKitSave={handleSubmit} />
        </Card>
        <div className="col-span-1 row-span-1 p-4">
          <Typography className="text-thryveGray" variant="h3">
            PREVIEW:
          </Typography>
          <KitPreviewCard kitPreview={preview} />
        </div>

        <Card className="col-span-1 row-span-5">
          <Typography className="text-thryveGray my-4" variant="h3">
            TEMPLATES:
          </Typography>

          <KitTemplatesList handleSelected={setSelectedTemplates} selected={selectedTemplates} />

          <Typography className="text-thryveGray my-4" variant="h3">
            RESOURCES:
          </Typography>

          <PlaybookResourcesList handleSelected={setSelectedResources} resources={selectedResources} />
        </Card>
      </section>
    </article>
  );
}

export default AdminKitCreate;
